/** Убирает все пробельные символы — в email/login и пароле их быть не должно. */
export function stripAuthWhitespace(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s+/g, '');
}
